module.exports = __webpack_public_path__ + "img/seta-mobile.e4ef96ea.png";